// Opções técnicas oficiais pré-definidas da Ficha de Orçamento organizadas por categoria (orcamento_tipo)
const FICHA_TECNICA_PRESET_OPTIONS = {
  // 1. Cores e MDF
  cor_interna: [
    { label: 'Branco TX', desc: 'Padrão caixaria interna' },
    { label: 'Gianduia Puro', desc: 'Linha Cristallo' },
    { label: 'Carvalho Brun', desc: 'Linha Thera' },
    { label: 'Freijó Imperial', desc: 'Linha Essencial' },
    { label: 'Off White', desc: 'Linha Essencial' },
    { label: 'Grafite Trama', desc: 'Linha Trama' },
    { label: 'Preto Cristallo', desc: 'Linha Cristallo' },
    { label: 'Nogueira Bourbon', desc: 'Linha Design' }
  ],
  cor_externa: [
    { label: 'Branco TX', desc: 'Padrão Marcenaria' },
    { label: 'Gianduia Puro', desc: 'Linha Cristallo (Alto Brilho)' },
    { label: 'Carvalho Brun', desc: 'Linha Thera' },
    { label: 'Freijó Imperial', desc: 'Linha Essencial' },
    { label: 'Nogueira Bourbon', desc: 'Linha Design' },
    { label: 'Off White', desc: 'Linha Essencial' },
    { label: 'Timborana Silvestre', desc: 'Linha Thera' },
    { label: 'Marrom Retrô', desc: 'Linha Essencial' },
    { label: 'Hibisco', desc: 'Linha Essencial' },
    { label: 'Bege Papiro', desc: 'Linha Essencial' },
    { label: 'Moss Absoluto', desc: 'Linha Design' },
    { label: 'Pérola Absoluto', desc: 'Linha Design' },
    { label: 'Fusion', desc: 'Linha Conceito' },
    { label: 'Linho Belga', desc: 'Linha Trama' },
    { label: 'Downtown', desc: 'Linha Conceito' },
    { label: 'Bétula', desc: 'Linha Essencial Wood' },
    { label: 'Carvalho Malva', desc: 'Linha Design' },
    { label: 'Teka Soho', desc: 'Linha Prisma' },
    { label: 'Nogueira Asti', desc: 'Linha Design' },
    { label: 'Blush', desc: 'Linha Essencial' },
    { label: 'Azul Profundo', desc: 'Linha Essencial' },
    { label: 'Carvalho Dian', desc: 'Linha Thera' },
    { label: 'Carvalho Lir', desc: 'Linha Thera' },
    { label: 'Nazca', desc: 'Linha Conceito' },
    { label: 'Oásis', desc: 'Linha Trama' },
    { label: 'Palha', desc: 'Linha Trama' },
    { label: 'Branco Diamante Acetinatta', desc: 'Linha Acetinatta' },
    { label: 'Opala Cristallo', desc: 'Linha Cristallo' },
    { label: 'Tartufo', desc: 'Linha Acetinatta' },
    { label: 'Grafite Trama', desc: 'Linha Trama' },
    { label: 'Preto Cristallo', desc: 'Linha Cristallo' }
  ],
  cor_moveis: [
    { label: 'Branco TX', desc: 'MDF Padrão' },
    { label: 'Madeirado Linha Essencial', desc: 'Padrão Madeirado suave' },
    { label: 'Madeirado Linha Design', desc: 'Padrão Madeirado nobre' },
    { label: 'Unicolor Cristallo', desc: 'Alto Brilho / Laca' }
  ],

  // 2. Portas, Caixaria e Aberturas
  modelo_acabamento_portas: [
    { label: 'Todas retas', desc: 'Frentes lisas tradicionais sem usinagem' },
    { label: 'Todas provençais', desc: 'Frentes usinadas estilo clássico / provençal' },
    { label: 'Todas ripadas', desc: 'Frentes com frisos ripados em relevo' },
    { label: 'Parte inferior provençal e parte superior reta', desc: 'Misto: provençal embaixo e reta em cima' },
    { label: 'Parte inferior reta e superior com vidros', desc: 'Misto: lisa embaixo e perfil de vidro em cima' },
    { label: 'Parte superior provençal e parte inferior reta', desc: 'Misto: provençal em cima e reta embaixo' }
  ],
  modelo_portas: [
    { label: 'Porta de Abrir (Giro)', desc: 'Sistema com dobradiças convencionais ou amortecedor' },
    { label: 'Porta de Correr (Deslizante)', desc: 'Sistema com trilhos e guias deslizantes' },
    { label: 'Porta Basculante', desc: 'Abertura para cima com pistão a gás ou articulação' }
  ],
  modelo_portas_mov: [
    { label: 'De Abrir', desc: 'Porta de giro tradicional' },
    { label: 'De Correr', desc: 'Porta de correr tradicional' },
    { label: 'Trilho convencional', desc: 'Sistema apoiado sobre trilhos de alumínio padrão' },
    { label: 'Kit Dominus', desc: 'Sistema suspenso de correr com amortecimento e guias superiores' },
    { label: 'Sistema Coplanar', desc: 'Portas em linha no mesmo plano, abrindo em sobreposição suave' }
  ],
  modelo_corpo_armario: [
    { label: 'Normal', desc: 'Estrutura tradicional (15mm / 18mm)' },
    { label: 'Embutido', desc: 'Portas embutidas alinhadas à caixa do móvel' },
    { label: 'Engrossado', desc: 'Laterais ou tampos duplos/engrossados de maior espessura (30mm+)' }
  ],
  corpo_armario: [
    { label: 'Normal (15mm/18mm)', desc: 'Estrutura padrão de fábrica' },
    { label: 'Embutido', desc: 'Caixa rente às portas' },
    { label: 'Engrossado (30mm+)', desc: 'Estrutura robusta reforçada' }
  ],
  modelo_puxadores: [
    { label: 'Puxador Cava', desc: 'Usinado diretamente na madeira (45° / cava plana)' },
    { label: 'Sem Puxador / Fecho-Toque', desc: 'Pulsador magnético Tip-On / Push-open' },
    { label: 'Puxador Perfil Alumínio', desc: 'Perfil de alumínio embutido na borda' },
    { label: 'Puxador Ponto / Concha', desc: 'Puxador pontual metálico aparafusado' },
    { label: 'Puxador Alça / Barra', desc: 'Barra metálica tubular de sobrepor' }
  ],
  tipo_puxador_externo: [
    { label: 'Puxador Cava 45°', desc: 'Cava chanfrada na própria porta' },
    { label: 'Puxador Perfil Slim', desc: 'Perfil metálico embutido' },
    { label: 'Puxador Barra Preto Fosco', desc: 'Puxador barra contemporâneo' }
  ],
  puxador_embutido: [
    { label: 'Perfil G / J', desc: 'Perfil gola em alumínio anodizado' },
    { label: 'Cava Usinada', desc: 'Usinagem na própria chapa' },
    { label: 'Perfil Oculto', desc: 'Perfil fixo atrás do móvel' }
  ],
  cor_armacao: [
    { label: 'Preto Fosco', desc: 'Perfil de alumínio preto anodizado' },
    { label: 'Bronze', desc: 'Perfil de alumínio cor bronze' },
    { label: 'Prata / Inox', desc: 'Perfil de alumínio anodizado natural' },
    { label: 'Dourado / Gold', desc: 'Perfil de alumínio acabamento dourado' }
  ],

  // 3. LED e Acabamento Inferior
  acabamento_inferior: [
    { label: 'Acabamento em Pedra', desc: 'Móvel assentado diretamente na base de alvenaria/pedra' },
    { label: 'Pé de Inox', desc: 'Pés metálicos de inox aparentes reguláveis' },
    { label: 'Rodinha / Rodízio', desc: 'Rodízios para movimentação do móvel' },
    { label: 'Suspenso / Flutuante', desc: 'Fixado na parede sem contato com o chão' }
  ],
  led_tipo: [
    { label: 'Perfil de LED Embutido', desc: 'Canaleta de alumínio usinada com fita de LED COB' },
    { label: 'Perfil de LED Sobrepor', desc: 'Perfil externo colado ou parafusado' },
    { label: 'Fita de LED com Difusor', desc: 'Perfil slim com difusor leitoso anti-ofuscamento' }
  ],
  led_cor: [
    { label: 'Quente (2700K - 3000K)', desc: 'Iluminação acolhedora amarelada' },
    { label: 'Neutro (4000K)', desc: 'Iluminação balanceada luz do dia' },
    { label: 'Frio (6000K - 6500K)', desc: 'Iluminação branca intensa' }
  ],
  led_posicao: [
    { label: 'Inferior dos aéreos', desc: 'Foco na bancada de trabalho' },
    { label: 'Interna das cristaleiras/nichos', desc: 'Iluminação de destaque em prateleiras' },
    { label: 'No rodapé inferior', desc: 'Iluminação indireta flutuante' },
    { label: 'Vertical nos montantes', desc: 'Iluminação de closet de cima a baixo' }
  ],

  // 4. Portas de Vidro / Reflecta
  modelo_vidro: [
    { label: 'Reflecta bronze', desc: 'Vidro espelhado bronze translúcido' },
    { label: 'Reflecta prata', desc: 'Vidro espelhado prata translúcido' },
    { label: 'Espelho normal', desc: 'Espelho cristal prata reflexivo tradicional' },
    { label: 'Espelho bronze', desc: 'Espelho com tonalidade bronze' },
    { label: 'Espelho fumê', desc: 'Espelho escurecido grafite/fumê' },
    { label: 'Incolor', desc: 'Vidro transparente liso incolor' },
    { label: 'Canelado', desc: 'Vidro ondulado retrô com textura canelada' }
  ],
  puxador_vidro: [
    { label: 'Puxador Aba Integrado ao Perfil', desc: 'Usinado na própria moldura de alumínio' },
    { label: 'Puxador Sobreposto no Vidro', desc: 'Colado com fita estrutural UV' },
    { label: 'Facetato', desc: 'Puxador facetado fixado no perfil' }
  ],

  // 5. Acessórios e Cabideiros
  modelo_cabide: [
    { label: 'Cabideiro Comum', desc: 'Tubo cabideiro oval cromado padrão com suportes' },
    { label: 'Cabideiro Iluminado', desc: 'Tubo metálico com fita de LED integrada' },
    { label: 'Cabideiro Extensivo (Basculante)', desc: 'Mecanismo articulado pantográfico para partes altas' }
  ],
  paineis_parede: [
    { label: 'Acima do rodapé', desc: 'Painel que começa acima do rodapé existente' },
    { label: 'Até o chão, suspenso apenas com bigarrilo', desc: 'Painel de piso ao teto com recuo flutuante' }
  ],
  cor_ferragem: [
    { label: 'Preto fosco', desc: 'Ferragens, perfis e parafusos pretos' },
    { label: 'Dourado / Gold', desc: 'Ferragens e perfis dourados' },
    { label: 'Rose Gold', desc: 'Acabamento acobreado rose' },
    { label: 'Branco', desc: 'Pintura eletrostática branca' }
  ],

  // 6. Eletros e Itens Embutidos
  itens_embutidos: [
    { label: 'Forno de Embutir', desc: 'Nicho com respiro traseiro e isolamento térmico' },
    { label: 'Micro-ondas de Embutir', desc: 'Nicho padrão com furação de tomada' },
    { label: 'Cooktop', desc: 'Corte na bancada e reforço de travessas' },
    { label: 'Cervejeira', desc: 'Nicho ventilado para livre circulação' },
    { label: 'Adega Climatizada', desc: 'Nicho sob medida para adega' },
    { label: 'Coifa / Depurador', desc: 'Duto embutido no aéreo' },
    { label: 'Frigobar', desc: 'Nicho inferior para refrigeração' },
    { label: 'Botijão de gás', desc: 'Espaço com grade de ventilação inferior' },
    { label: 'TV Embutida', desc: 'Painel com passa-fios e nicho dedicado' },
    { label: 'Cofre Oculto', desc: 'Fundo falso ou compartimento secreto com chave/senha' }
  ]
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { FICHA_TECNICA_PRESET_OPTIONS };
}
